// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"9352bcb9","224":"712d1947","399":"63b0fd2f","695":"d7bed601","745":"9fd0bebe","881":"c42ec176","936":"238eb804"}[chunkId] + ".chunk.js";
};